module.exports = __webpack_public_path__ + "static/media/Screenshot4.8c7b7351.png";